import { apiClient } from './auth';

export const dashboardService = {
  async getStats() {
    return apiClient.get('/admin/dashboard/stats');
  },

  async getRevenueChart(days: number = 30) {
    return apiClient.get(`/admin/dashboard/revenue?days=${days}`);
  },

  async getOccupancyChart(days: number = 7) {
    return apiClient.get(`/admin/dashboard/occupancy?days=${days}`);
  },

  async getRecentTickets(limit: number = 10) {
    return apiClient.get(`/admin/dashboard/recent-tickets?limit=${limit}`);
  },

  async getAlerts() {
    return apiClient.get('/admin/dashboard/alerts');
  },

  async getTopParkings(limit: number = 5) {
    return apiClient.get(`/admin/dashboard/top-parkings?limit=${limit}`);
  },
};
